import { User } from 'dashboard/models/user';

export const userDisplayName = (user?: User): string | undefined => {
  return user
    ? [user.attributes['name-first'], user.attributes['name-last']].filter(Boolean).join(' ') ||
        user.attributes['email-address']
    : undefined;
};
